export const PUBLIC_CORE_API_URL =
  process.env.NEXT_PUBLIC_CORE_API_URL ?? "http://localhost:3002";

export const SERVER_CORE_API_URL =
  process.env.CORE_API_URL ?? "http://localhost:3002";
